import { useIntl } from "react-intl";

import { Box, Link } from "@mui/material";

import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";

// Styles
import companySummaryStyles from "./CompanySummary.styles";

// Types
import { flattenSectorProductsDomain } from "services/company/company.functions";

const CompanySummaryFooter = ({
    companyData,
}: {
    companyData: ReturnType<typeof flattenSectorProductsDomain> | undefined;
}) => {
    const classes = companySummaryStyles();
    const intl = useIntl();

    const domain = companyData?.domains?.at(0)?.domain;

    return (
        <Box className={classes.summaryFooterRoot}>
            {domain && (
                <Link className={classes.summaryLink} href={domain} target="_blank">
                    {intl.formatMessage({ id: "companySummary.website" })}
                    <CustomIcon icon={icons.circledChevronRight} />
                </Link>
            )}
        </Box>
    );
};

export default CompanySummaryFooter;
